import {
  ServiceIcon,
  Spacer,
  Text,
  TooltipPosition,
  TooltipWrapper,
} from "@zapier/design-system";

import styles from "./SummaryApps.module.css";
import getAppIconUrl from "../../utils/getAppIconUrl";
import useServiceById from "../../hooks/useServiceById";
import cleanUpAppId from "../../utils/cleanUpAppId";

type Props = {
  uniqueApps: string[];
  tooltipPosition?: TooltipPosition;
  darkMode?: boolean;
};

export function SummaryApps({
  uniqueApps,
  tooltipPosition = "north",
  darkMode = false,
}: Props) {
  const getService = useServiceById();

  return (
    <>
      <Text type="SmallPrint3" color={darkMode ? "PrimeWhite" : "GrayWarm10"}>
        Apps
      </Text>
      <Spacer height={5} />
      {uniqueApps.length === 0 && (
        <Text type="SmallPrint1" color="GrayWarm6">
          <span>Software referenced will be displayed here.</span>
        </Text>
      )}
      {uniqueApps.length > 0 && (
        <ul className={styles.appsList}>
          {uniqueApps.map((appId) => {
            const service = getService(appId);
            const serviceName = service?.name ?? cleanUpAppId(appId);
            const images = service?.images;
            const size = 40;

            return (
              <li className={styles.appItem} key={appId}>
                <TooltipWrapper
                  position={tooltipPosition}
                  content={serviceName}
                >
                  {() => (
                    <ServiceIcon
                      alt={`${serviceName} icon`}
                      hasBorder={true}
                      size={size}
                      hasShadow={false}
                      serviceName={serviceName}
                      src={getAppIconUrl(appId, images, size)}
                    />
                  )}
                </TooltipWrapper>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
